<template>
<div
  class="main--text">
  <v-row
    v-if="teacher"
    dense>
    <v-col
      md=4
      sm=4
      cols=12>
      <v-container
        fluid>
        <v-row
          justify=center
          justify-sm=end
          justify-md=end>
          <v-col
            cols=auto>
            <v-avatar size="110px">
              <img :src="teacher.iconUrl" alt="">
            </v-avatar>
          </v-col>
        </v-row>
        <div  style="text-align:right">
          <h2 :class="leftItemsStyle">{{ teacher.fullName() }}</h2>
          <p :class="leftItemsStyle">
            {{ teacher.flatFullName() }}<br>
            {{ teacher.genderInJapanese() }}
          </p>
        </div>
      </v-container>
    </v-col>
    <v-col md=8 sm=8 cols=12>
      <v-container
        fluid>
        <h5>スケジュール</h5>
        <p class="item--text">{{ offer.lesson.schedule.toString()}}</p>
        <h5>一回あたり報酬</h5>
        <p class="item--text">{{ offer.lesson.wage }}円</p>
        <h5>コメント</h5>
        <p class="item--text line--feed">{{ offer.lesson.note }}</p>
      </v-container>
    </v-col>
  </v-row>
  <v-row>
    <v-col
      class="no--vertical--padding">
      <v-container
        class="no--vertical--padding"
        fluid>
        <v-row
          dense
          justify=end>
          <v-col
            cols=auto>
            <v-btn
              rounded
              outlined
              color="grey"
              @click="disagree"
              >今回は見送る
            </v-btn>
          </v-col>
          <v-col
            cols=auto>
            <v-btn
              rounded
              outlined
              color="primary"
              @click="agree"
              >この応募を受ける
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-col>
  </v-row>
</div>
</template>

<script>
import { TeacherRepository } from "@/repository/TeacherRepository"
import { firestore } from "@/repository/client/firestore"

export default {
  props: {
    offer: Object
  },
  data () {
    return {
      teacher: null,
      teacherRepo: null,
      leftItemsStyle: "text-center text-sm-right text-md-right"
    }
  },
  methods: {
    async agree() {
      // this.teacher = await this.teacherRepo.update(this.teacher.registerLesson(this.offer.lesson))
      this.$emit("agree-button-click", this.offer)
    },
    async disagree() {
      this.$emit("disagree-button-click", this.offer)
    }
  },
  created: async function () {
    this.teacherRepo = new TeacherRepository(firestore)
    this.teacher = await this.teacherRepo.find(this.offer.senderId)
  }
}
</script>

<style scoped>
.item--text {
  font-size: 1.1rem;
}

.no--vertical--padding {
  padding: 0px 12px;
}
</style>
